import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomAlertComponent } from '../../commons/custom-alert/custom-alert.component';

@Component({
  selector: 'ejemplo-alert',
  templateUrl: './ejemplo-alert.component.html',
  styleUrls: ['./ejemplo-alert.component.scss']
})
export class EjemploAlertComponent implements OnInit {
  data_ejemplo = [
    {raza:'Yorkshire', nombre:'Eluney', edad:7},
    {raza:'Calle con vereda', nombre:'Tofu', edad:12},
    {raza:'Pseudo Persa', nombre:'Cocotom', edad:1, gato:true},
  ]
  
  htmlString =`
  <table class="table table-striped">
    <thead>
      <tr class="tr-cabezal">
        <th colspan='2'>Una tabla </th>
      </tr>
      <tr >
        <th >Nombre</th>
        <th >Raza</th>
      </tr>
    </thead>
    <tbody >`
  
  constructor(public modal: NgbModal) { 
  }

  ngOnInit(): void {
    this.data_ejemplo.forEach(e=>
      this.htmlString += `<tr><td>${e.nombre}</td><td>${e.raza}</td></tr>`
    )
    this.htmlString += ` </tbody> </table> `
  }

  abrirAlerta(){
    const alerta = this.modal.open(CustomAlertComponent)
    alerta.componentInstance.titulo='Modal de alerta'
    alerta.componentInstance.content= this.htmlString
  }

  abrirConfirmacion(){
    const confirmar = this.modal.open(CustomAlertComponent)
    confirmar.componentInstance.titulo='Modal de confirmación'
    confirmar.componentInstance.content='¿Te gustan más los perros que los gatos?'
    confirmar.componentInstance.confirm=true
    confirmar.componentInstance.acepta.subscribe({
      next:(res:Boolean)=>{
        const alerta = this.modal.open(CustomAlertComponent)
        if(res==true) {
          alerta.componentInstance.content=`<p class='alerta'>A Cocotom no le gustó esto.</p>`
        }else {
          alerta.componentInstance.content='Se te otorgó la bendicion del gato'
        }confirmar.close()
      }
    })
  }

}
